<div class="modal-header">
    <h6 class="modal-title pull-left"> {{item.id==''?'Add':'Edit' }} Time</h6>
    <button type="button" class="close btn" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-body">
    <div class="row ">
        <div class="col">
            <div class="form-group">
                <label for="ID">From :</label> <br>
                <ngb-timepicker [(ngModel)]="from_time" [meridian]="meridian" class="d-flex justify-content-center" (ngModelChange)="fromTimeChange()"></ngb-timepicker>
            </div>
        </div>
        <div class="col">
            <div class="form-group">
                <label for="ID">To :</label> <br>
                <ngb-timepicker [(ngModel)]="to_time" [meridian]="meridian" class="d-flex justify-content-center" (ngModelChange)="toTimeChange()"></ngb-timepicker>
            </div>
        </div>
    </div>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-danger btn-sm" (click)="activeModal.dismiss()">Cancel</button>&nbsp;
    <button type="button" class="btn btn-primary btn-sm" (click)="save()">Save</button>
</div>